export default {"src":"/_next/static/image/public/icons/twitter.1301be43bf17897ba188a1a7af61dd32.svg","height":18,"width":21};